import React from 'react';
import useTranslate from '../hooks/useTranslate';

const PageNotFound = () => {
  const t = useTranslate();

  return <div>{t('pageNoteFound')}</div>;
};

export default PageNotFound;
